/** RepresentativeChip — honest marker on surfaces rendered from a synthetic
 *  view-model until their backend lands. Never let representative data read as served. */
import React from 'react'

export default function RepresentativeChip({ label = 'representative — pending backend' }: { label?: string }): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-dashed border-amber font-mono text-[10.5px] tracking-[.06em] uppercase text-amber">
      {label}
    </span>
  )
}
